<div class="page-container" [ngClass]="{ sticky: navigationIsSticky, sidebar: showSidebar }">
  <div class="page-main-navigation-container dont-print">
    <patternlib-header-portal
      [portalName]="portalName"
      [sticky]="true"
      sticky-by-default="false"
      brand-logo="assets/img/logo.png"
      (lhTabClick)="onMainNavigationClickCollect($any($event))"
      (lhSticky)="onMainNaviationSticky($any($event))"
      (lhClickBrandLogo)="onClickBrandLogo()"
      [attr.padding]="getMainNavigationPadding()"
      [appResizeObserver]
      (appResizeEvent)="onHeaderResizeEvent($any($event))"
    >
      <ng-content select="[main-navigation]"></ng-content>

      <div slot="more">
        <div style="display: flex; justify-content: flex-end; align-items: center">
          <div>
            <lh-language-select
              [show]="showLanguageFlyout"
              [activeLanguage]="activeLanguage"
              (showChange)="onLanguageFlyoutChange($any($event))"
              [languages]="languages"
              (onLanguageChange)="selectLanguage($any($event))"
            ></lh-language-select>
          </div>
          <div *ngIf="helpLink" class="ml-6 cursor-pointer">
            <patternlib-icon icon-name="info-circle" size="40px" (click)="onHelpClick()"></patternlib-icon>
          </div>
          <div *ngIf="enableNotifications" class="ml-6">
            <patternlib-notification-flyout-service
              [environment]="environment"
              [accessToken]="accessToken"
              [baseUrl]="communicationHubBaseUrl"
            >
            </patternlib-notification-flyout-service>
          </div>
          <div *ngIf="enableAppLauncher" class="ml-6">
            <patternlib-applauncher-service
              [environment]="environment"
              [accessToken]="accessToken"
              [baseUrl]="applauncherBaseUrl"
            >
            </patternlib-applauncher-service>
          </div>
          <div *ngIf="user" class="ml-6">
            <lh-user-control [show]="showAvatarFlyout" (showChange)="onAvatarFlyoutChange($any($event))" [user]="user">
              <ng-content select="[main-menu-avatar]"></ng-content>
            </lh-user-control>
          </div>
        </div>
      </div>
    </patternlib-header-portal>
  </div>

  <div
    class="layout-grid"
    [ngClass]="{
      'sidebar-visible': sidebarIsVisible(),
      'sidebar-expanded': sidebarExpanded,
      'desktop': isDesktopOrLarger()
    }"
  >
    <patternlib-grid-item
      id="sidebar-column"
      class="sidebar-column dont-print"
      *ngIf="showSidebar && !hideSidebar"
      z-index="25"
    >
      <patternlib-sidebar
        id="sidebar-sticky"
        [attr.collapsed]="!sidebarExpanded"
        (lhChangeItem)="onSidebarChangeCollect($any($event))"
        (lhCollapse)="onSidebarCollapseCollect($any($event))"
        [ngClass]="{ 'sidebar-sticky': navigationIsSticky }"
      >
        <ng-content select="[sidebar]"></ng-content>
      </patternlib-sidebar>
    </patternlib-grid-item>

    <patternlib-grid-item>
      <patternlib-flex
        flow="column wrap"
        justify-content="space-between"
        background-color="var(--color-steel-100)"
        height="100%"
      >
        <patternlib-flex-item width="100%">
          <div id="full-content-container" class="full-content-container">
            <div
              class="banner-container"
              #bannerWrapper
              [ngClass]="{
                'has-content': $any(bannerWrapper).children?.length > 0
              }"
            >
              <ng-content select="[banner]"></ng-content>
            </div>

            <div
              class="breadcrumb-container dont-print"
              [class]="
                backRoute || $any(breadcrumbComponent)?.el?.querySelectorAll('patternlib-breadcrumb-item')?.length
                  ? 'has-content'
                  : 'has-no-content'
              "
            >
              <lh-back-button *ngIf="backRoute" [backRoute]="backRoute" class="back-button"></lh-back-button>
              <patternlib-breadcrumb (lhClick)="onBreadcrumbClickCollect($any($event))" #breadcrumbComponent>
                <ng-content select="[breadcrumbs]"></ng-content>
              </patternlib-breadcrumb>
            </div>

            <div class="content-container" [ngClass]="{ 'sidebar-expanded': sidebarExpanded }">
              <ng-content select="[content]"></ng-content>
            </div>
          </div>
        </patternlib-flex-item>
        <div class="footer-container dont-print" [ngClass]="{ 'sidebar-expanded': sidebarExpanded }">
          <lh-footer
            id="lh-footer"
            [ngStyle]="{ 'display': 'block' }"
            [links]="footerLinks"
            [additionalLinks]="footerAdditionalLinks"
            [showArrowIcon]="footerShowGoToTopIcon"
            [footerFixed]="footerFixed"
            [appResizeObserver]
            (appResizeEvent)="onFooterResizeEvent($any($event))"
          >
          </lh-footer>
        </div>
      </patternlib-flex>
    </patternlib-grid-item>
  </div>
</div>
